module.exports = __webpack_public_path__ + "img/derpa.80b05c47.png";